// extracted by mini-css-extract-plugin
export default {"container":"ku-z","heading":"lu-z","text":"mu-z","info":"nu-z","link":"ou-z","fullMaxWidth":"pu-z"};